<template>
  <div>
    <ValidationObserver ref="validator" slim>
      <div class="cmh-modal-layout">
        <div class="cmh-modal-layout main-title-modal">
          <ModalDialog :closeable="$t('common.close')" :open.sync="isMainTitleModalOpen">
            <cmh-modal-partners>
              <template #header>
                <div class="modal__header">
                  <img :src="require('@/assets/cmh-logo.svg')" />
                  <i18n path="new-connection-cmh.landingPageModalHeader" scope="global" tag="p">
                    <span class="lib__text-weight-600">
                      Connect my Home
                    </span>
                  </i18n>
                </div>
              </template>
              <template #content>
                <div class="modal__content">
                  <p>{{ $t('new-connection-cmh.askTodayOrangeAndProximusForFree') }}</p>
                  <p>{{ $t('new-connection-cmh.freeProximusAndOrangeDisclaimer') }}</p>
                </div>
              </template>
            </cmh-modal-partners>
          </ModalDialog>
        </div>
        <div class="cmh-modal-layout service-info-modal">
          <ModalDialog :closeable="$t('common.close')" :open.sync="isServiceInfoModalOpen">
            <img class="service-info-modal cmh-logo" :src="require('@/assets/cmh-logo.svg')" />
            <p class="service-info-modal">{{ $t('new-connection-cmh.underTechnicalReservations') }}</p>
          </ModalDialog>
        </div>
      </div>
      <!-- NEW SECTION HERO -->
      <section class="hero">
        <div class="hero__container normal">
          <div class="hero__content">
            <img class="hero__logo" :src="require('@/assets/cmh-logo.svg')" />
            <h1>
              <span v-html="$t('new-connection-cmh.mainTitle')" />
              <i @click="openMainTitleModal()" class="hero__tooltip fa fa-info-circle " />
            </h1>

          </div>
          <cmh-logo class="hero__content" />
          <button type="button" @click="scrollToCmhWizard()">
            <i class="fa fa-arrow-down"></i>
            <span>{{ $t('new-connection-cmh.howDoesItWork') }}</span>
          </button>
        </div>
      </section>
      <div id="zipcode-input-container" :class="{ 'container-zipcode--active': subCity || isServiceCalled }"
        class="container-zipcode lib__bg-primary">
        <p class="lib__text-center lib__text-weight-600">{{ $t('new-connection-cmh.verifyingServiceAvailabilityInCity')
          }}</p>
        <zipCode-locality-selector v-model="subCity" class="zipcode-margin" :inputClass="'zipcode-input'"
          :placeHolder="$t('new-connection-cmh.zipCodeOrLocality')" :onClick="scrollToZipCodeInput"
          :unorderedListContainerClass="'autocomplete-suggestions'"
          :suggestionItemClass="'autocomplete-suggestion-item'"
          :suggestionItemTextClass="'autocomplete-suggestion-text'" :onBlur="deactivateOverlay" />
      </div>
      <div v-if="subCity || isServiceCalled" class="connection-container-available">
        <div v-if="isAvailable">
          <div v-if="isAvailable">
            <p class="lib__text-weight-300 available-connection-top-paragraph" v-html="isFullyAvailable
              ? $t('new-connection-cmh.iCanAskForThoseOperators')
              : $t('new-connection-cmh.youCanAskForThoseOperators')
              "></p>
          </div>
          <available-service-display :subCity="subCity" />
          <div class="introduce-demand-link">
            <router-link :to="getUrl(lang)">
              <div class="lib__btn lib__btn--primary lib__btn--rounded">
                {{ $t('new-connection-cmh.iIntroduceMyDemand') }}
              </div>
            </router-link>
          </div>
          <div>
            <div class="available-connection-bottom-paragraph" v-if="!isFullyAvailable">
              <p class="available-connection-bottom-text">
                {{ $t('new-connection-cmh.someOperatorsNotAvailable') }}
              </p>
              <cmh-providers-external-links :isOrangeDisplayed="!subCity.connectMyHomeInformation.vooAvailable"
                :isProximusDisplayed="!subCity.connectMyHomeInformation.proximusAvailable"
                :isSwdeDisplayed="!subCity.connectMyHomeInformation.swdeAvailable" />
            </div>
          </div>
        </div>
        <div v-if="!isAvailable">
          <div v-if="isElectricityManaged || isGasOresManaged">
            <div class="available-connections-header">
              <i class="available-connection-header-icon-times fa fa-exclamation-circle lib__text-info"></i>
              <div class="available-connection-header-paragraph">
                <p>{{ $t('new-connection-cmh.serviceIsNotYetAvailable') }}</p>
                <p v-if="availabilityActivationDate">{{ availabilityActivationText }}</p>
              </div>
            </div>
            <p class="available-connection-bottom-text lib__text-weight-600 lib__text-center">
              {{ $t('new-connection-cmh.youCanStillAskYourGasAndElectricityConnection') }}
            </p>
            <div class="introduce-demand-link">
              <router-link :to="getUrl(lang)">
                <div class="lib__btn lib__btn--primary lib__btn--rounded">
                  {{ $t('new-connection-cmh.iIntroduceMyDemand') }}
                </div>
              </router-link>
            </div>
            <p class="available-connection-bottom-text lib__text-center">
              {{ $t('new-connection-cmh.youCanIntroduceOtherConnection') }}
            </p>
            <div :style="{ marginBottom: '50px' }">
              <cmh-providers-external-links isOrangeDisplayed isProximusDisplayed isSwdeDisplayed />
            </div>
          </div>
          <div v-else>
            <div v-if="!comingFromOresWebSite" class="available-connections-header">
              <i class="available-connection-header-icon-times fa fa-times-circle"></i>
              <span class="available-connection-header-paragraph"
                v-html="$t('new-connection-cmh.serviceIsNotAvailable')"></span>
            </div>
            <div>
              <div class="available-connection-bottom-paragraph ores-web-site">
                <i v-if="comingFromOresWebSite"
                  class="available-connection-header-icon-times fa fa-times-circle ores-web-site"></i>
                <p class="available-connection-bottom-text not-available ores-web-site"
                  v-html="$t('new-connection-cmh.oresIsNotYourOperator')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAvailable">
        <div id="connection-bottom-container" class="connection-container-bottom">
          <p class="rectangle-wizard-title">{{ $t('new-connection-wizard.wizardTitle') }} :</p>
          <div class="rectangle-wizard-container">
            <wizard-display :wizardStepDefinitions="wizardStepDefinitions" :isPagingActivated="isPagingActivated" />
          </div>
          <faq-display />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { WizardStepDefinition } from '@/models/wizard-step-definition'
import WizardDisplay from '@/components/display/WizardDisplay.vue'
import ZipCodeLocalitySelector from '@/components/inputs/Address/ZipCodeLocalitySelector.vue'
import AvailableServiceDisplay from '@/components/display/AvailableServiceDisplay.vue'
import CmhLogo from '@/components/display/CmhNewConnection/LandingPage/CmhLogo.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { ManagerName, SubCity } from '@/models'
import Step from '@/components/steps/Step'
import { debounce } from 'ts-debounce'
import { Mutation, State } from 'vuex-class'
import CmhProvidersExternalLinks from '@/components/display/CmhProvidersExternalLinks.vue'
import CmhModalPartners from '@/components/steps/new-connection-cmh/modal/CmhModalPartners.vue'
import FaqDisplay from '@/components/display/FaqDisplay.vue'
import { routes } from '@/router'
import { dateService } from '@ores/vue-library'
import { newConnectionCmhGtmService as gtmService, GtmEventType } from '@/services/gtm'
import { CmhAddressPoint } from '@/models/cmh-address-point'

@Component({
  components: {
    FaqDisplay,
    CmhProvidersExternalLinks,
    CmhModalPartners,
    WizardDisplay,
    AvailableServiceDisplay,
    ZipCodeLocalitySelector,
    CmhLogo
  },
  name: 'cmh-landing-page-step'
})
export default class CmhLandingPageStep extends Step {
  //#region [Property]
  @Prop({ type: Boolean, required: false, default: false }) public readonly comingFromOresWebSite!: boolean
  @Prop({ type: String, required: true }) public readonly lang!: string
  //#endregion

  //#region [Data]
  @State('subCity', { namespace: 'newConnectionCmh/landingPage' })
  public stateSubCity!: SubCity
  @State('addressPoint', { namespace: 'newConnectionCmh/cmhAddress' })
  public stateAddressPoint!: CmhAddressPoint

  public zipCodeOrSubCity: string = ''
  public wizardStepDefinitions: WizardStepDefinition[] = [
    {
      imageFileName: 'rectangle-wizard-step1.svg',
      bodyTextPath: 'new-connection-wizard.firstStep'
    },
    {
      imageFileName: 'rectangle-wizard-step2.svg',
      bodyTextPath: 'new-connection-wizard.secondStep'
    },
    {
      imageFileName: 'rectangle-wizard-step3.svg',
      bodyTextPath: 'new-connection-wizard.thirdStep'
    }
  ]
  public subCity: SubCity | null = null
  public isOverlayDisplayed: boolean = false
  public isPagingActivated: boolean = false
  public isServiceCalled: boolean = false

  public isMainTitleModalOpen: boolean = false
  public isServiceInfoModalOpen: boolean = false
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'newConnectionCmh/landingPage' })
  private store!: (index: SubCity | null) => void
  //#endregion

  //#region [Methods]
  public created() {
    this.setWizardPaging()
    this.setWizardPaging = debounce(this.setWizardPaging, 200)
    window.addEventListener('resize', this.setWizardPaging)
  }

  public mounted() {
    const mainContainer = document.getElementsByClassName('lib__main__container')[0] as HTMLElement
    mainContainer.style.maxWidth = '1440px'
    mainContainer.style.paddingLeft = '0px'
    mainContainer.style.paddingRight = '0px'

    gtmService.sendGtmEvent({
      eventType: GtmEventType.page_view,
      step: -1,
      language: this.$i18n.locale
    })

  }

  public destroyed() {
    window.removeEventListener('resize', this.setWizardPaging)
    const mainContainer = document.getElementsByClassName('lib__main__container')[0] as HTMLElement
    mainContainer.style.maxWidth = ''
    mainContainer.style.paddingLeft = ''
    mainContainer.style.paddingRight = ''
    if (this.subCity) {
      this.store(this.subCity)
    }
  }

  public scrollToZipCodeInput(): void {
    const zipcodeContainer = document.getElementById('zipcode-input-container')
    if (zipcodeContainer) {
      zipcodeContainer.scrollIntoView()
      this.isOverlayDisplayed = true
    }
  }

  public scrollToCmhWizard(): void {
    const connectionBottomContainer = document.getElementById('connection-bottom-container')
    if (connectionBottomContainer) {
      connectionBottomContainer.scrollIntoView()
    }
  }

  @Watch('subCity')
  public onSubCityChanged() {
    this.isServiceCalled = true
    if (this.subCity === null) {
      this.isOverlayDisplayed = false
    }
  }

  public deactivateOverlay(): void {
    this.isOverlayDisplayed = false
  }

  public setWizardPaging(): void {
    this.isPagingActivated = !(window.innerWidth >= 1024)
  }

  public openMainTitleModal(): void {
    this.isMainTitleModalOpen = true
  }

  public openServiceInfoModal(): void {
    this.isServiceInfoModalOpen = true
  }

  public getUrl(lang: string): string {
    return routes.find((r) => r.name === 'new-connection-cmh')!.paths[lang]
  }
  //#endregion

  //#region [Computed]
  private get isAvailable() {
    if (this.subCity) {
      return this.subCity.connectMyHomeActivated && this.subCity.connectMyHomeInformation
    }
    if (this.isServiceCalled && this.subCity == null) {
      return false
    }

    return true
  }

  private get isFullyAvailable() {
    if (!this.subCity?.connectMyHomeInformation)
      return false

    return (
      this.isAvailable &&
      this.subCity.connectMyHomeInformation.proximusAvailable &&
      this.subCity.connectMyHomeInformation.vooAvailable &&
      this.subCity.connectMyHomeInformation.swdeAvailable &&
      (this.subCity.gridManagers.gasManager?.name !== ManagerName.resa
        || (this.subCity.gridManagers.gasManager?.name === ManagerName.resa
          && this.subCity?.connectMyHomeInformation?.resaGazAvailable))
    )
  }

  private get isElectricityManaged(): boolean {
    return this.subCity?.gridManagers?.electricityManager?.isOres ?? false
  }

  private get isGasOresManaged(): boolean {
    return this.subCity?.gridManagers?.gasManager?.isOres ?? false
  }

  private get availabilityActivationDate(): Date | null {
    if (this.subCity) {
      return this.subCity.connectMyHomeActivationDate
    }
    return null
  }

  private get availabilityActivationText(): string {
    return this.$t('new-connection-cmh.serviceWillBeAvailableOn', [
      dateService.displayDate(this.subCity!.connectMyHomeActivationDate!)
    ]).toString()
  }
  //#endregion
}
</script>

<style>
/** Hero Section */
/** RESET */
.hero,
.hero>*,
.container-zipcode,
.container-zipcode>* {
  margin: 0;
  padding: 0;
  box-sizing: border-box
}

.hero {
  position: relative;
  overflow: hidden;
  background: linear-gradient(45deg, rgba(215, 212, 237, 0.3) 0%, #d7d4ed 100%);
  padding-inline: 2rem;
  padding-block: 2rem;
}

.hero>*,
.hero__partner {
  z-index: 1;
}

.hero::after {
  content: '';
  position: absolute;
  background: url('../../../assets/waves.svg') no-repeat;
  width: 1440px;
  height: 711px;
  top: 45%;
  left: 20%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
}

.hero__container {
  display: grid;
  place-items: center;
}

.hero__container.normal {
  place-items: normal;
}

.hero__container button {
  /** reset */
  background: none;
  border: none;
  padding: 0;
  /** end reset */
  display: inline-flex;
  align-items: center;
  margin-block-start: 2.4rem;
  color: #494D8D;
  font-size: 1.2rem;
  gap: 0.5rem;
}

.hero__container button i {
  font-size: 1.4rem;
  text-decoration: none;
  color: #494D8D;
}

.hero__container button span {
  font-size: 1.4rem;
  text-decoration: underline #494D8D;
}

.hero__content {
  display: grid;
  place-items: center;
  gap: 2.4rem;
}

.hero__content h1 {
  text-align: center;
  font-size: 2.4rem;
  line-height: 1.25;
  font-weight: 400;
  color: #494D8D;
}

.hero__tooltip {
  font-size: 15px;
  margin-inline-start: .8rem;
  vertical-align: middle;
  color: #0096CE;
  cursor: pointer;
}

/** ZIPCODE */
.container-zipcode {
  position: relative;
  display: grid;
  place-items: center;
  gap: 1rem;
  margin: 0;
  margin-inline: auto;
  padding-block: 1.6rem;
  padding-inline: 2rem;
}

.container-zipcode--active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  inline-size: 2rem;
  block-size: 2rem;
  background-color: #ffd300;
  transform: translate(-50%, 50%) rotate(45deg);
  border-radius: 2px;
  z-index: -1;
}

.container-zipcode p {
  margin-block: 0;
  font-size: 1.6rem;
}

.container-zipcode .zipcode-margin {
  align-self: start;
}

.container-zipcode .zipcode-margin .lib__field {
  margin: 0;
}


.container-zipcode .autocomplete-suggestions {
  position: absolute;
  top: 50px;
  left: 0;
  inline-size: 100%;
  margin: 0;
  margin-block-start: 1rem;
  padding: 0;
}

.connection-container-available {
  margin-block-start: 2.4rem;
}

/** MEDIA QUERIES SMALL TABLET */
@media only screen and (min-width: 569px) {
  .container-zipcode {
    margin-block-start: 0;
  }
}

/** MEDIA QUERIES TABLET */
@media only screen and (min-width: 769px) {
  .hero {
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    padding-inline: 4rem;
    /** Compensate overlay from the zip code container */
    padding-block-end: 82px;
  }

  .hero::after {
    top: unset;
    left: 0;
    bottom: 0;
    transform: none;
  }

  .hero__partner {
    justify-self: self-end;
  }

  .hero__content {
    justify-items: start;
    gap: 4rem;
  }

  .hero__content h1 {
    text-align: start;
  }

  .hero__container {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  .hero__container button {
    display: none;
  }

  .container-zipcode {
    position: relative;
    margin-inline: auto;
    /** Create overlay effect on top of the hero */
    margin-block-start: -82px;
  }

  .container-zipcode p {
    font-size: 1.8rem;
  }

  .connection-container-available {
    margin-block-start: 4rem;
  }
}

/** MEDIA QUERIES MEDIUM SCREEN */
@media only screen and (min-width: 961px) {
  .container-zipcode p {
    font-size: 2rem;
  }

  .hero__content h1 {
    font-size: 3.6rem;
    line-height: 1.2;
  }

  .hero__tooltip {
    font-size: 18px;
  }
}

/** MEDIA QUERIES LARGE SCREEN */
@media only screen and (min-width: 1140px) {
  .hero {
    padding-inline: 8.8rem;
  }

  .hero__logo {
    inline-size: 215px;
  }
}

/** MEDIA QUERIES VERY LARGE SCREEN */
@media only screen and (min-width: 1410px) {
  .hero__content h1 {
    font-size: 4.8rem;
  }

  .hero__logo {
    inline-size: 250px;
  }
}

@media screen and (max-width: 576px) {
  div.cmh-modal-layout.main-title-modal div.lib__dialogs__box {
    height: 433px;
    width: 300px;
    padding: 10px;
  }

  div.cmh-modal-layout.service-info-modal div.lib__dialogs__box {
    height: 190px;
    width: 300px;
    padding: 10px;
  }
}

@media (min-width: 768px) {
  div.cmh-modal-layout.service-info-modal .lib__dialogs:not(.lib__dialogs--small):not(.lib__dialogs--medium) .lib__dialogs__box {
    width: 400px;
  }
}

div.cmh-modal-layout div.lib__dialogs__box {
  box-shadow: 0 8px 16px 0 rgba(12, 0, 51, 0.1);
}

div.cmh-modal-layout div.lib__dialogs.lib__dialogs--open {
  opacity: 0.95;
  background-color: #f9f8f8;
}
</style>

<style scoped>
.modal__header p {
  color: #494d8d;
  font-size: 18px;
}

.modal__content p {
  font-size: 15px;
  font-weight: 300;
}

@media screen and (max-width: 576px) {
  .modal__header img {
    margin-inline: auto;
    display: block;
  }

  .modal__header p {
    font-size: 15px;
  }

  .modal__content p {
    font-size: 12px;
  }
}

.zipcode-auto-complete-overlay {
  background-color: #dfe2df;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 90%;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.zipcode-margin {
  margin: 0 auto;
  width: 320px;
}

.available-service-container {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(52px, 152px);
  place-content: center;
  gap: 1.6rem;
}

@media screen and (min-width: 577px) {
  .connection-container-top {
    max-height: 600px;
  }

  .service-info-modal.cmh-logo {
    width: 210px;
    margin: auto;
    display: block;
  }

  p.service-info-modal {
    height: 65px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 20px;
    margin: 20px auto 0px;
  }

  .main-title-modal.logos {
    width: 400px;
    height: 100px;
    margin: 0px auto 10px;
  }

  .main-title-modal.cmh-logo {
    width: 210px;
    margin: 20px auto;
    display: block;
  }

  .main-title-modal.top-paragraph {
    height: 75px;
    width: 600px;
    color: #494d8d;
    font-family: 'Open Sans';
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 20px;
    margin: auto;
  }

  .main-title-modal.bottom-paragraph {
    height: 150px;
    width: 700px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    margin: auto;
  }

  .main-title-modal.ores-logo {
    position: absolute;
  }

  .main-title-modal.swde-logo {
    position: absolute;
    margin-left: 125px;
    margin-top: 5px;
  }

  .main-title-modal.proximus-logo {
    position: absolute;
    margin-left: 210px;
    margin-top: 15px;
  }

  .main-title-modal.voo-logo {
    position: absolute;
    margin-left: 310px;
    margin-top: 25px;
  }

  .rectangle-wizard-container {
    margin-top: 50px;
    text-align: center;
    margin-left: -20px;
  }

  .zipcode-label {
    padding-left: 20px;
    padding-right: 20px;
    color: #171a2f;
    font-family: 'Open Sans';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
    margin: 38px auto 20px;
  }

  .container-zipcode {
    border-radius: 4;
    height: 162px;
    width: 100%;
    max-width: 837px;
    z-index: 2;
  }

  .ores-ores-logo {
    position: absolute;
    margin-top: -20px;
    margin-left: 74px;
    width: 77px;
    height: 63px;
  }

  .ores-swde-logo {
    margin-left: 185px;
    width: 37px;
    height: 57px;
    margin-top: -24px;
  }

  .ores-proximus-logo {
    position: absolute;
    margin-left: 45px;
    margin-top: -10px;
    width: 55px;
    height: 46px;
  }

  .ores-voo-logo {
    position: absolute;
    margin-left: 130px;
    width: 52px;
    height: 21px;
  }

  .ores-cmh-offering-text {
    color: #5a519e;
    font-size: 16px;
    margin-left: 90px;
  }

  .connection-top-paragraph {
    color: #494d8d;
    font-family: 'Open Sans';
    font-size: 40px;
    letter-spacing: 0;
    padding-left: 90px;
    padding-right: 90px;
    margin-top: 90px;
  }

  .connection-top-paragraph.ores-web-site {
    height: 243px;
    line-height: 30px;
    margin-top: 45px;
    font-size: 24px;
  }

  .sm-background-image {
    background-image: url('../../../assets/hero-img-mobile-2x-without-border.png');
    background-repeat: no-repeat;
    background-size: 100% 600px;
  }

  .sm-background-gradient {
    height: 600px;
    background: linear-gradient(45deg, rgba(215, 212, 237, 0.3) 0%, #d7d4ed 100%);
  }

  .ores-cmh-logo {
    height: 76px;
    width: 229px;
    margin-left: 90px;
  }

  .rectangle-wizard-title {
    height: 36px;
    width: 500px;
    color: #000000;
    font-family: 'Open Sans';
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 36px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding-top: 20px;
  }

  .connection-container-bottom {
    background-color: #f9f8f8;
  }

  .lib__btn.lib__btn--primary.lib__btn--rounded {
    margin-top: 20px;
    width: 320px;
    text-align: center;
    padding-left: 70px;
  }

  .introduce-demand-link {
    width: 320px;
    margin: 20px auto 32px;
  }

  .available-connections-header {
    text-align: center;
  }

  .available-connection-header-paragraph {
    display: inline-block;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 24px;
    letter-spacing: 0;
    line-height: 20px;
    padding-bottom: 20px;
  }

  .available-connection-header-paragraph>p {
    display: block;
  }

  .available-connection-header-icon-check {
    display: inline-block;
    font-size: 64px;
    margin-right: 20px;
    vertical-align: top;
  }

  .available-connection-top-paragraph {
    text-align: center;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 20px;
  }

  .available-service-container {
    margin: 32px auto 0;
    width: 560px;
  }

  .available-connection-bottom-paragraph {
    text-align: center;
    font-size: 18px;
    margin: auto auto 100px;
    width: 600px;
  }

  .available-connection-header-icon-times {
    display: inline-block;
    font-size: 64px;
    width: 64px;
    height: 64px;
    border-radius: 24.75px;
    margin-right: 20px;
    vertical-align: top;
  }

  .available-connection-header-icon-times.ores-web-site {
    display: block;
    float: left;
  }

  .available-connection-bottom-text {
    margin: auto auto 32px;
    width: 600px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 20px;
  }

  p>i.fa.fa-info-circle {
    height: 15px;
    width: 15px;
    font-size: 15px;
    color: #0096ce;
  }

  .available-connection-bottom-paragraph.ores-web-site {
    padding-top: 120px;
  }
}

@media screen and (max-width: 576px) {
  .top-gradient.ores-web-site {
    background-color: #34b4e4;
    height: 150px;
    width: 100vw;
    position: relative;
  }

  .introduce-demand-link {
    width: 320px;
    margin: 20px auto 32px;
  }

  .rectangle-wizard-container {
    width: 360px;
    margin: 0px auto;
  }

  .hero-img-mobile {
    width: 100vw;
    height: 300px;
    margin-bottom: -300px;
  }

  .hero-img-mobile.ores-web-site {
    margin-bottom: -200px;
  }

  .service-info-modal.cmh-logo {
    height: 54px;
    width: 163px;
    margin: 10px 50px;
  }

  p.service-info-modal {
    height: 65px;
    width: 258px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 20px;
  }

  .main-title-modal.logos {
    width: 260px;
    height: 70px;
  }

  .main-title-modal.cmh-logo {
    height: 54px;
    width: 163px;
    margin: 10px 50px;
  }

  .main-title-modal.top-paragraph {
    height: 101px;
    width: 250px;
    color: #494d8d;
    font-family: 'Open Sans';
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 20px;
    margin: auto;
  }

  .main-title-modal.bottom-paragraph {
    height: 150px;
    width: 250px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    margin: auto;
  }

  .main-title-modal.ores-logo {
    height: 56px;
    width: 69px;
    position: absolute;
  }

  .main-title-modal.swde-logo {
    height: 51px;
    width: 33px;
    position: absolute;
    margin-left: 75px;
    margin-top: 5px;
  }

  .main-title-modal.proximus-logo {
    height: 40px;
    width: 49px;
    position: absolute;
    margin-left: 133px;
    margin-top: 10px;
  }

  .main-title-modal.voo-logo {
    height: 19px;
    width: 47px;
    position: absolute;
    margin-left: 204px;
    margin-top: 17px;
  }

  .mobile-connection-container-zipcode-arrow {
    height: 20px;
    width: 20px;
    transform: rotate(315deg);
    border-radius: 2px;
    padding: 0px;
    margin: -10px auto 0;
  }

  .available-connection-bottom-text {
    margin: 0px auto 0px;
    width: 85%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
  }

  .available-connection-bottom-text.not-available {
    margin: 0px auto 50px;
  }

  .lib__btn.lib__btn--primary.lib__btn--rounded {
    height: 51px;
    width: 320px;
  }

  .available-service-container {
    margin: 20px 20px 10px;
    min-width: 304px;
  }

  .available-connections-header {
    width: 80%;
    height: 80px;
    margin: 20px auto 0px;
  }

  .available-connection-top-paragraph {
    width: 75%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
    margin: 10px auto;
  }

  .available-connection-header-paragraph {
    width: 230px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
    padding-bottom: 80px;
  }

  .available-connection-header-paragraph p {
    display: block;
  }

  .available-connection-header-icon-check {
    display: block;
    float: left;
    margin: 0px 10px;
  }

  .available-connection-header-icon-times {
    display: block;
    float: left;
    margin: 0px 10px;
    font-size: 48px;
    width: 48px;
    height: 48px;
    border-radius: 24.75px;
    border-radius: 24.75px;
  }

  .connection-container-available {
    width: 100vw;
  }

  .connection-container-top {
    width: 100vw;
  }

  .connection-container-bottom {
    width: 100%;
    background-color: #f9f8f8;
  }

  .connection-top-paragraph {
    width: 320px;
    color: #ffffff;
    font-size: 26px;
    margin: 20px auto 0;
    letter-spacing: normal;
    text-align: center;
  }

  .connection-top-paragraph.ores-web-site {
    width: 90%;
    font-size: 20px;
  }

  .container-zipcode {
    width: 100%;

    /* height: 134px; **/
    z-index: 2;
  }

  .zipcode-label {
    height: 40px;
    width: 280px;
    color: #0c0033;
    font-family: 'Open Sans';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    margin-block-end: 10px;
    margin-inline: auto;
    /* margin: 20px auto 10px; **/
  }

  p>i.fa.fa-info-circle {
    height: 15px;
    width: 15px;
    font-size: 15px;
  }

  .ores-cmh-offering-text {
    color: #5a519e;
    font-family: 'Open Sans';
    width: 100%;
    text-align: center;
    margin: 10px auto;
  }

  .mobile-ores-cmh-offering {
    width: 220px;
    height: 200px;
    margin: 55px auto 0px;
  }

  .logo-container {
    width: 188px;
    height: 63px;
    margin: 0px auto;
  }

  .ores-ores-logo {
    display: inline-block;
    vertical-align: top;
    width: 56px;
    height: 45px;
  }

  .ores-swde-logo {
    display: inline-block;
    vertical-align: top;
    margin-top: 3px;
    margin-left: 15px;
    width: 23px;
    height: 38px;
  }

  .ores-proximus-logo {
    display: inline-block;
    vertical-align: top;
    margin-top: 10px;
    margin-left: 25px;
    width: 40px;
    height: 32px;
  }

  .ores-voo-logo {
    display: inline-block;
    vertical-align: top;
    margin-top: 15px;
    margin-left: 15px;
    width: 38px;
    height: 15px;
  }

  .ores-cmh-how-container {
    margin: 10px auto;
    color: #494d8d;
    text-decoration: underline;
    width: 100%;
  }

  .mobile-gradient-top {
    margin-top: 20px;
    margin-bottom: -100px;
    width: 100%;
  }

  .mobile-gradient {
    margin-top: 96px;
    height: 200px;
    margin-bottom: -270px;
    background: linear-gradient(180deg, #f3f1fe 0%, #d7d4ed 100%);
  }

  .assets-images-lp-hero-img-mobile {
    height: 320px;
    position: absolute;
  }

  .rectangle-wizard-title {
    width: 90%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    margin: 0px auto 20px;
    padding: 20px 0px 0px;
  }

  .available-connection-header-icon-times.ores-web-site {
    margin: 20px 20px 80px;
  }

  .available-connection-bottom-text.not-available.ores-web-site {
    margin-top: 25px;
  }
}

@media screen and (min-width: 577px) and (max-width: 1443px) {
  .connection-top-paragraph {
    font-size: 32px;
    margin-right: 20px;
  }

  .connection-top-paragraph.ores-web-site {
    height: 243px;
    margin-top: 45px;
    font-size: 18px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .connection-top-paragraph {
    font-size: 26px;
    margin-left: 40px;
    padding-left: 0px;
  }

  .connection-top-paragraph.ores-web-site {
    height: 243px;
    margin-top: 45px;
    font-size: 18px;
  }

  .ores-cmh-logo {
    margin-left: 40px;
  }

  .container-zipcode {
    width: 100%;
  }

  .ores-cmh-offering-text {
    margin-left: 40px;
  }

  .ores-ores-logo {
    margin-left: 25px;
  }

  .ores-swde-logo {
    margin-left: 134px;
  }
}
</style>
